import Router, { useRouter } from "next/router";
import * as React from "react";
import "sanitize.css";
import { RecoilRoot } from "recoil";
import { ThemeProvider } from "styled-components";
import { LoadingIndicator } from "~/components/atoms/LoadingIndicator";
import { DefaultMetaTag } from "faqSrc/components/modules/metaTag";

const theme = {
  supportDarkMode: true,
};

export default function GlobalStateLayout({
  children,
}: {
  children: React.ReactElement;
}) {
  const [loading, setLoading] = React.useState(false);
  const router = useRouter();

  React.useEffect(() => {
    if (!router.pathname) {
      return;
    }

    const start = () => {
      setLoading(true);
    };
    const end = () => {
      setLoading(false);
    };
    Router.events.on("routeChangeStart", start);
    Router.events.on("routeChangeComplete", end);
    Router.events.on("routeChangeError", end);
    return () => {
      Router.events.off("routeChangeStart", start);
      Router.events.off("routeChangeComplete", end);
      Router.events.off("routeChangeError", end);
    };
  }, [router.pathname]);

  return (
    <RecoilRoot>
      <ThemeProvider theme={theme}>
        {/* Refer https://github.com/catnose99/next-head-seo#default-seo-settings */}
        <DefaultMetaTag />
        {loading ? <LoadingIndicator /> : children}
      </ThemeProvider>
    </RecoilRoot>
  );
}
